<!-- Translated: yes -->
<template>
  <Modal @close="localCloseModal" :wide="false" width="500px">

    <h1 v-if="!scanningOpen">{{ $t('skipass.refill-header') }}</h1>

    <div class="blocked tab-picker center">
      <label class="uppercase">Välj sparat eller lägg in ett nytt</label>
      <div :class="'box checkboxes'">
        <Checkbox special-class="skipass-user" label="Nytt" label-position="right" :value="false" :valuebinder.sync="tabSaved"></Checkbox>
        <Checkbox special-class="skipass-user" label="Sparat" label-position="right" :value="true" :valuebinder.sync="tabSaved"></Checkbox>
      </div>
    </div>

    <div v-if="tabSaved" class="tab-saved">
      <div v-if="!loggedIn">
        <Login @login="onLogin" />
      </div>

      <div v-if="loggedIn && !skipasses.length && !loading">
        <div class="blocked info">
          <b><icon name="info" :scale="1.4" />Inga liftkort</b>
          <p v-if="foundNotAllowedDelivery">Vi hittade inga sparade liftkort.</p>
        </div>
      </div>

      <div v-if="loggedIn && loading">
        <div class="blocked center">
          <Loading :show="loading" :static="true" />
        </div>
      </div>

      <div v-if="loggedIn && skipasses.length">
        <div class="blocked center">
          <b>Välj bland dina kort</b>
          <br>
          <Dropdown
            :options="skipassesAsSelect"
            :valuebinder.sync="cardId"
            :validated="cardId"
            label="Välj liftkort"
            />
        </div>

        <div class="blocked center">
          <button @click="useNumber()" :disabled="!cardId">Använd</button>
        </div>
      </div>
    </div>

    <div v-if="!tabSaved" class="tab-new">
      <div class="blocked center" v-if="!scanningOpen">
        <b>{{ $t('skipass.enter-number') }}</b>
        <br />
        <div class="number-wrapper">
          <Dropdown
            :options="options"
            :valuebinder.sync="prefix"
            :validated="prefix"
            :value-as-label="true"
            label="00"
            />
          <input type="tel" :class="{validated: validate(), error: error()}" v-mask="pattern" :placeholder="placeholder" v-model="number">
          <button @click.stop="scanningOpen = true" class="button small">
            <icon name="camera-white" :scale="2" />
          </button>
        </div>
      </div>

      <div class="blocked center" v-if="scanningOpen">
        <button @click.stop="$refs.scanner.shutdown(); scanningOpen = false">Avbryt skanning</button>
        <Scanner :on-success="onScannerSuccess" ref="scanner" />
      </div>

      <!-- <div class="blocked center" v-if="!scanningOpen">
        <pre>{{ fullNumber }}</pre>
      </div> -->

      <div class="blocked center info error-box" style="text-align:left;" v-if="wasScanned && error()">
        <b><icon name="info" :scale="1.4" />Ogiltigt kortnummer</b>
        <p>Vänligen korrigera manuellt eller försök skanna igen. Observera att gamla liftkort inte alltid kan skannas.</p>
      </div>

      <div class="blocked center" v-if="!scanningOpen">
        <button @click="setNumber()" :disabled="!validate()">{{ $t('skipass.add-number') }}</button>
      </div>

      <div class="blocked info">
        <b><icon name="info" :scale="1.4" />{{ $t('skipass.old-keycard-title') }}</b>
        <p>{{ $t('skipass.old-keycard-text') }}</p>
      </div>

      <div class="blocked center keycard-img">
        <img src="https://static.booking.branasgruppen.se/static/img/liftkort-nr.jpg" />
      </div>
    </div>

  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import API from '@/classes/API';
import Modal from '@/components/components/Modal';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';
import Checkbox from '@/components/components/Checkbox';
import Login from '@/components/payments/Login';
import Loading from '@/components/components/Loading';
import Scanner from '@/Scanner';

import checkdigit from 'checkdigit';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CounterButton,
    Dropdown,
    AccomodationPeriodConfirm,
    Checkbox,
    Login,
    Loading,
    Scanner,
  },
  data() {
    return {
      number: '',
      prefix: '',
      pattern: '####-####-####-####-####-#',
      placeholder: '0000-0000-0000-0000-0000-0',
      tabSaved: false,
      skipasses: [],
      cardId: '',
      loading: false,
      scanningOpen: false,
      wasScanned: false,
      scannedNumber: '',
    };
  },
  mounted() {
    this.fetch();

    if (this.params.prefillPrefix) {
      this.prefix = this.params.prefillPrefix;
    }
    if (this.params.prefillNumber) {
      this.number = this.params.prefillNumber;
    }

    if (this.params.pass) {
      this.tabSaved = true;
    }
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    fullNumber() {
      return `${this.prefix}-${this.number}`;
    },
    fullNumberWithoutDashes() {
      return `${this.prefix}${this.number}`.replace(/-/g, '');
    },
    onScannerSuccess() {
      return (code) => {
        // Assume full number is scanned
        this.number = code.replace(/-/g, '').slice(2);
        this.prefix = code.replace(/-/g, '').slice(0, 2);

        // Force the prefix to one of the two options
        if (this.prefix !== '01' && this.prefix !== '30') {
          if (this.prefix === '38') {
            this.prefix = '30';
          } else {
            this.prefix = '01';
          }
        }

        this.scannedNumber = this.fullNumber;

        this.wasScanned = true;

        setTimeout(() => {
          // Stop the camera after a successful scan
          if (this.$refs.scanner && this.$refs.scanner.shutdown) {
            this.$refs.scanner.shutdown();
          }
          setTimeout(() => {
            this.scanningOpen = false;
          }, 1);
        }, 1000);
      };
    },
    options() {
      return [
        {
          title: '01',
          value: '01',
        }, {
          title: '30',
          value: '30',
        },
      ];
    },
    skipassesAsSelect() {
      return this.skipasses.map(s => ({
        value: s.guid,
        title: s.name ? `${s.name} (${s.number})` : s.number,
      }));
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
    ]),
    async fetch() {
      this.loading = true;
      const { skipasses } = await API.get('/account/user');
      this.skipasses = skipasses || [];
      this.loading = false;

      if (this.params.pass) {
        this.cardId = this.params.pass.guid;
      }
    },
    validate() {
      const validated = this.fullNumberWithoutDashes ?
        checkdigit.mod10.isValid(this.fullNumberWithoutDashes) : false;
      return this.fullNumberWithoutDashes.length === 23 && validated;
    },
    error() {
      const validated = this.fullNumberWithoutDashes ?
        checkdigit.mod10.isValid(this.fullNumberWithoutDashes) : false;
      if (this.fullNumberWithoutDashes.length === 23 && validated) {
        this.wasScanned = false;
      }
      return this.fullNumberWithoutDashes.length === 23 && !validated;
    },
    setNumber() {
      if (this.loggedIn) {
        const $this = this;

        this.openModal(['GeneralModal', {
          title: 'Spara liftkort',
          content: '<p>Vill du spara detta skipass till ditt konto?</p>',
          buttons: [
            {
              title: 'Ja',
              class: '',
              click: () => {
                API.post('/account/skipasses/add', {
                  number: this.fullNumber,
                }).then((r) => {
                  this.params.onSetNumber(this.prefix, this.number, r.pass);
                  this.closeModal();
                });
              },
            },
            {
              title: 'Nej tack',
              class: '',
              click: () => {
                this.params.onSetNumber(this.prefix, this.number);
                $this.closeModal();
              },
            },
          ],
        }]);
      } else {
        this.params.onSetNumber(this.prefix, this.number);
        this.closeModal();
      }
    },
    useNumber() {
      const card = this.skipasses.find(s => s.guid === this.cardId);
      if (card) {
        const prefix = card.number.slice(0, 2);
        const number = card.number.slice(3);

        this.params.onSetNumber(prefix, number, card);
      } else {
        console.warn(`Could not find selected card ${this.cardId}`);
      }
      this.closeModal();
    },
    onLogin() {
      this.fetch();
    },
    localCloseModal() {
      if (this.$refs.scanner && this.$refs.scanner.shutdown) {
        this.$refs.scanner.shutdown();
        setTimeout(() => {
          this.closeModal();
        }, 1);
      } else {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.tab-picker
  margin-top: 1em

.tab-new
  .dropdown-wrapper
    width 75px
    height: 50px
    display: inline-block;
    position: relative;
    top: 5px
    &.validated
      position: relative;
      top: 4px

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  +max-mobile()
    padding: 15px 10px!important
    margin-top: 10px

h1.accomodation-title
  font-size 19px
  font-weight bold
  text-align center
  color #262626
  text-transform none
  border-radius 2px
  background-color #ecf5f8
  border solid 1px #bfd9e1
  padding 7px 20px
  display inline-block


h1
  margin-bottom: 2rem

.keycard-img img
  width: 200px

.blocked
  margin-bottom space-2
  width:374px;
  max-width:100%;
  margin-left: auto;
  margin-right: auto;

button
  font-size: 12px
  padding: 9px 20px 5px;

b
  uppercase()

input
  input()
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.06em;
  color: rgba(38, 38, 38, 0.74);
  width 250px
  max-width 250px
  margin-top: 7px
  font-family: monospace;
  padding: 8px 10px 7px 10px;
  position: relative;
  top: 3px;

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  max-width 420px
  width 100%
  &.blue
    background-color: #ecf5f8;
    border 0
    text-align: center
  &.green
    margin-bottom: 0
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 0.7em
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.padding
  padding 0 27px
h1
  margin-top 20px

input
  &.validated
    background-color: #5aa478;
    border-color #c7dcb7;
    color white
    uppercase()
  &.error
    border-color warning

select
  height 45px
  border-radius 4px
  background-color #ffffff
  border solid 2px #bfd9e1
  width 100%

.number-wrapper
  display flex
  align-items flex-start
  justify-content space-evenly
  & > *
    margin-top 0
    margin-bottom 0
    height 45px
    position: relative
    top 4px
  & > button.small
    padding-top 0

.error-box
  warning-box()
</style>



// WEBPACK FOOTER //
// SkiPassRefill.vue?141fed37